module.exports = __webpack_public_path__ + "static/media/video.d5ced40c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/HearthHouse/video.jpg
// module id = 201
// module chunks = 0